import { createSlice } from '@reduxjs/toolkit';
import { MODULE_PROJECTS } from 'modules';

/**
 * Redux-Slice für die Projekt-Übersicht.
 *
 * Die Projektliste wird aus der Modul-Registry (src/modules/index.js)
 * vorbefüllt. Der Store hält zusätzlich die zuletzt besuchte Projekt-ID,
 * damit die Übersichtsseite das aktuelle Projekt hervorheben kann.
 *
 * @typedef {import('types/dto').ProjectDTO} ProjectDTO
 */

/**
 * @typedef {Object} ProjectsState
 * @property {ProjectDTO[]} items
 * @property {string | null} lastVisitedId
 */

/** @type {ProjectsState} */
const initialState = {
  items: MODULE_PROJECTS.map((p) => ({ ...p })),
  lastVisitedId: null,
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    /**
     * Merkt sich, welches Projekt zuletzt geöffnet wurde.
     * @param {ProjectsState} state
     * @param {{ payload: string }} action
     */
    projectVisited(state, action) {
      state.lastVisitedId = action.payload;
    },
  },
});

export const { projectVisited } = projectsSlice.actions;

// --- Selektoren (entkoppeln Komponenten von der State-Struktur) ---

/** @param {{ projects: ProjectsState }} state */
export const selectAllProjects = (state) => state.projects.items;

/** @param {{ projects: ProjectsState }} state */
export const selectLastVisitedId = (state) => state.projects.lastVisitedId;

/**
 * @param {string} id
 * @returns {(state: { projects: ProjectsState }) => ProjectDTO | undefined}
 */
export const selectProjectById = (id) => (state) =>
  state.projects.items.find((p) => p.id === id);

export default projectsSlice.reducer;
